


$(function(){
  $('.slick-slide1').click(function(){
    $('.audio-1').toggleClass('active');
$('.audio-0,.audio-2,.audio-3,.audio-4,.audio-5').removeClass('active');
  });
});

$(function(){
  $('.slick-slide2').click(function(){
    $('.audio-2').toggleClass('active');
 $('.audio-0,.audio-1,.audio-3,.audio-4,.audio-5').removeClass('active');
  });
});

$(function(){
  $('.slick-slide3').click(function(){
    $('.audio-3').toggleClass('active');
 $('.audio-0,.audio-1,.audio-2,.audio-4,.audio-5').removeClass('active');
  });
});

$(function(){
  $('.slick-slide4').click(function(){
    $('.audio-4').toggleClass('active');
 $('.audio-0,.audio-1,.audio-2,.audio-3,.audio-5').removeClass('active');
  });
});
$(function(){
  $('.slick-slide5').click(function(){
    $('.audio-5').toggleClass('active');
 $('.audio-0,.audio-1,.audio-2,.audio-3,.audio-4').removeClass('active');
  });
});

